'use client';
import { memo } from 'react';
import type { ReactElement, RefObject } from 'react';
import { Cteamscarousel } from '../Cteamscarousel';
import type { CarouselTeamSelectInput, CteamscarouselRef } from '../Cteamscarousel';
import type { TeamData } from '../Cteamcard';
import { ContainerPreset } from '@/constants/componentPresets';
import { getHeroCarouselWrapperStyle } from './Chero.styles';
interface CheroTeamsCarouselProps {
    carouselRef: RefObject<CteamscarouselRef | null>;
    heroTeamsData: TeamData[];
    isMobile: boolean;
    isTeamsMounted: boolean;
    isTeamsVisible: boolean;
    onCenteredTeamChange: (team: TeamData | null) => void;
    onTeamSelect: (input: CarouselTeamSelectInput) => void;
}
export const CheroTeamsCarousel = memo(function CheroTeamsCarousel({ carouselRef, heroTeamsData, isMobile, isTeamsMounted, isTeamsVisible, onCenteredTeamChange, onTeamSelect, }: CheroTeamsCarouselProps): ReactElement {
    return (
      <div data-el="Chero/TeamsCarousel/Root" style={getHeroCarouselWrapperStyle({ isMobile })}>
        {isTeamsMounted && (<Cteamscarousel ref={carouselRef} teams={heroTeamsData} onTeamSelect={onTeamSelect} onCenteredTeamChange={onCenteredTeamChange} cardContainerPreset={ContainerPreset.ModalCard} entranceReady={isTeamsVisible}/>)}
      </div>
    );
});
